"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingSwitch = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSwitch = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 0.5rem;
`;
const SettingSwitch = (props) => {
    return (react_1.default.createElement(StyledSwitch, { className: 'form-check form-switch' },
        react_1.default.createElement("label", { className: 'form-check-label', htmlFor: props.id }, props.label),
        react_1.default.createElement("input", { checked: props.value, className: 'form-check-input', disabled: props.disabled, id: props.id, onChange: ({ target: { checked } }) => props.onChange(checked), type: 'checkbox' })));
};
exports.SettingSwitch = SettingSwitch;
